import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Excursion from "../pages/excursion/page";
import ExcursionsList from "../pages/excursions/page";
import OwnerLogin from "../pages/owner/login/page";
import OwnerDashboard from "../pages/owner/dashboard/page";
import AuthGuard from "../components/feature/AuthGuard";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/excursions",
    element: <ExcursionsList />,
  },
  {
    path: "/excursion/:slug",
    element: <Excursion />,
  },
  {
    path: "/owner/login",
    element: <OwnerLogin />,
  },
  {
    path: "/owner/dashboard",
    element: (
      <AuthGuard>
        <OwnerDashboard />
      </AuthGuard>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;